import { Card, CardActions, CardHeader, SxProps, Typography } from "@bvhi/ui-base";
import { ReactElement } from "react";
import { getAppConfig } from "../config/config";

interface Props {
  sx?: SxProps;
  cardActions?: ReactElement;
}

export const ErrorCard = ({ sx, cardActions }: Props) => {
  return (
    <Card sx={sx}>
      <CardHeader
        title="Oh nein! Es ist ein Fehler aufgetreten!"
        subheader={
          <Typography>
            Das tut uns Leid! Die Seite konnte leider nicht geladen werden. Sie können versuchen, die Seite neu zu laden. Wenn dieses
            Problem weiterhin besteht, können Sie sich gerne per&nbsp;<a href={`mailto:${getAppConfig().env.supportMailAdesso}`}>E-Mail</a>
            &nbsp;an uns wenden.
          </Typography>
        }
      />
      {cardActions && <CardActions>{cardActions}</CardActions>}
    </Card>
  );
};
